import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../Components/Common/ChartsDynamicColor";

const MostEngagedCategories = ({ dataColors }) => {
  var chartDatalabelsBarColors = getChartColorsArray(dataColors);
  const [chartData] = useState({
    series: [
      {
        name: "Danube Properties",
        data: [44, 55, 41, 37, 22, 43],
      },
      {
        name: "Danube Home",
        data: [53, 32, 33, 52, 13, 45],
      },
      {
        name: "Milano",
        data: [12, 17, 11, 9, 15, 11],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 500,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          barHeight: "100%",
          distributed: true,
          horizontal: true,
          dataLabels: {
            position: "bottom", // Data label position
          },
        },
      },
      colors: chartDatalabelsBarColors,
      dataLabels: {
        enabled: true,
        textAnchor: "start",
        style: {
          colors: ["#fff"],
          fontSize: "11px",
          padding: 10,
          fontWeight: 400,
        },
        formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val; // Custom label format
        },
        offsetX: 0,
        dropShadow: {
          enabled: false,
        },
      },
      stroke: {
        width: 5,
        colors: ["#fff"],
      },
      xaxis: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"], // Labels for each bar
      },
      yaxis: {
        title: {
          text: undefined,
        },
      },
      title: {
        // text: "Most Engaged Categories",
        align: "center",
        floating: true,
        style: {
          fontWeight: 400,
          fontSize: "12px",
        },
      },
      tooltip: {
        theme: "dark",
        x: {
          show: false,
        },
        y: {
          title: {
            formatter: function () {
              return "";
            },
          },
        },
      },
    },
  });

  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        className="apex-charts"
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={750}
      />
    </React.Fragment>
  );
};

export { MostEngagedCategories };
